$(onPageReady);

function onPageReady() {
    if ($('.graph-item__preview').length > 0) {
        require.ensure(
            ['./module'],
            () => {
                require('./module');
            },
            'five-years-results',
        );
    }
}



// WEBPACK FOOTER //
// ./js/main/page/five-years-results/index.js